import { render } from "./OrderFile.vue?vue&type=template&id=2f7f10db&scoped=true"
import script from "./OrderFile.vue?vue&type=script&lang=ts"
export * from "./OrderFile.vue?vue&type=script&lang=ts"

import "./OrderFile.vue?vue&type=style&index=0&id=2f7f10db&lang=scss"
import "./OrderFile.vue?vue&type=style&index=1&id=2f7f10db&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2f7f10db"

export default script